import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import {Bar} from "react-chartjs-2";
import Colors from "./Colors";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const IslandStatus = ({data}) => {
  if (!data) return null;

  // Obtener datos de islas
  const islandNames = Object.keys(data.islands);
  const islandValues = islandNames.map((name) => data.islands[name]);
  const total = islandValues.reduce((sum, count) => sum + count, 0);

  // Crear los labels del gráfico (nombres de islas)
  const labels = islandNames.map((name) =>
    name === "null" ? "Sin asignar" : name
  );

  // Crear múltiples datasets (uno para cada isla) siguiendo el patrón de AssetsFraction
  const datasets = [];

  islandNames.forEach((name, index) => {
    // Obtener colores para esta isla
    const typeIndex = index % Colors.types.length;
    const type = Colors.types[typeIndex];
    const backgroundColor = Colors.getBackgroundColor(type);
    const borderColor = Colors.getBorderColor(type);

    // Crear array de valores con ceros y el valor solo en la posición correspondiente
    const dataValues = Array(islandNames.length).fill(0);
    dataValues[index] = data.islands[name];

    // Agregar el dataset
    datasets.push({
      label: name === "null" ? "Sin asignar" : name,
      data: dataValues,
      backgroundColor: backgroundColor,
      borderColor: borderColor,
      borderWidth: 1,
    });
  });

  // Configuración del gráfico como AssetsFraction
  const DataBar = {
    labels: labels, // Nombres de las islas
    datasets: datasets,
  };

  // Opciones del gráfico como AssetsFraction
  const OptionsBar = {
    responsive: true,
    maintainAspectRatio: false, // Importante para controlar la altura
    plugins: {
      legend: {
        position: "top",
        labels: {
          usePointStyle: true,
          pointStyle: "rect",
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        text: data.title,
        font: {
          size: 16,
        },
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            if (tooltipItem.raw === 0) return null;
            const value = tooltipItem.raw;
            const percentage = ((value / total) * 100).toFixed(1);
            return `${tooltipItem.dataset.label}: ${value} contenedores (${percentage}%)`;
          },
        },
      },
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
  };

  return (
    <div className="mb-4">
      <div className="border" style={{height: "320px"}}>
        <Bar data={DataBar} options={OptionsBar} />
      </div>
    </div>
  );
};

export default IslandStatus;
